export default __webpack_public_path__ + "static/media/hermes-01.d423a5e2.jpg";